// pmgw-custom.js

// --- Konfiguration ---
const baumpatenschaftVariantIds = [
  50316068159752, // 15 €
  50324991017224, // 25 €
  50324991049992  // 50 €
];

const oekosystemVariantId = 50446286291208;

// --- Hilfsfunktionen ---
function getCart() {
  return fetch("/cart.js").then((res) => res.json());
}

function removeItemByVariantId(variantId) {
  console.log(`🧹 Entferne Produkt mit variant_id: ${variantId}`);
  return fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates: { [variantId]: 0 } }),
  });
}

function refreshCartDrawer() {
  document.dispatchEvent(
    new CustomEvent("cart:refresh", { detail: { open: true } })
  );
  document.dispatchEvent(new CustomEvent("cart:open"));
}

function adjustCartCountDisplay(cart) {
  // Öko-Produkt NICHT mitzählen
  const hiddenCount = cart.items.filter(
    (item) => item.variant_id === oekosystemVariantId
  ).length;

  const adjustedCount = Math.max(0, cart.item_count - hiddenCount);

  document.querySelectorAll("cart-count").forEach((cartCountEl) => {
    // Shadow DOM (für Animation)
    if (cartCountEl.shadowRoot && cartCountEl.shadowRoot.firstElementChild) {
      cartCountEl.shadowRoot.firstElementChild.textContent = adjustedCount;
    }

    // Fallback / Header
    cartCountEl.textContent = adjustedCount;

    const sr = cartCountEl.querySelector(".sr-only");
    if (sr) {
      sr.textContent = `${adjustedCount} Artikel`;
    }
  });

  console.log(`🧮 CartCount angepasst: ${cart.item_count} → ${adjustedCount}`);
}

/**
 * Zentrale Logik:
 * - Wenn Baumpatenschaft > 0 und Öko < Baumpatenschaft → Öko hinzufügen
 * - Wenn Baumpatenschaft = 0 und Öko > 0 → Öko entfernen
 */
function handleCartLogic(cart) {
  const patenschaftItems = cart.items.filter((item) =>
    baumpatenschaftVariantIds.includes(item.variant_id)
  );
  const oekosystemItems = cart.items.filter(
    (item) => item.variant_id === oekosystemVariantId
  );

  const patenschaftQty = patenschaftItems.reduce(
    (sum, item) => sum + item.quantity,
    0
  );
  const oekosystemQty = oekosystemItems.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  console.log(
    `🔍 handleCartLogic: Patenschaft=${patenschaftQty}, Öko=${oekosystemQty}`
  );

  // Fall 1: Keine Patenschaft mehr im Cart, aber Öko noch drin → Öko entfernen
  if (patenschaftQty === 0 && oekosystemQty > 0) {
    console.log("🟡 Keine Baumpatenschaft mehr → entferne Öko-Produkt");
    removeItemByVariantId(oekosystemVariantId)
      .then(() => {
        console.log("✅ Öko-Produkt entfernt");
        setTimeout(refreshCartDrawer, 300);
      })
      .catch((err) =>
        console.error("❌ Fehler beim Entfernen des Öko-Produkts:", err)
      );
    return;
  }

  // Fall 2: Patenschaft(en) im Cart, aber zu wenig Öko → Öko ergänzen
  if (patenschaftQty > 0 && oekosystemQty < patenschaftQty) {
    const fehlendeAnzahl = patenschaftQty - oekosystemQty;

    // Selling Plan aus erster Patenschaft-Zeile ziehen (falls vorhanden)
    const erstePatenschaft = patenschaftItems[0];
    const sellingPlanId =
      erstePatenschaft?.selling_plan_allocation?.selling_plan?.id;

    const ecoItemPayload = {
      id: oekosystemVariantId,
      quantity: fehlendeAnzahl,
    };

    if (sellingPlanId) {
      ecoItemPayload.selling_plan = sellingPlanId;
    }

    console.log(
      `🟢 Ergänze Öko-Produkt: +${fehlendeAnzahl}x (selling_plan=${sellingPlanId || "none"})`
    );

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [ecoItemPayload] }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Fehler beim automatischen Hinzufügen des Öko-Produkts");
        }
        return res.json();
      })
      .then(() => {
        console.log("✅ Öko-Produkt automatisch ergänzt");
        setTimeout(refreshCartDrawer, 300);
      })
      .catch((err) =>
        console.error("❌ Fehler beim automatischen Öko-Add:", err)
      );
  }

  // Sonst: alles konsistent → nichts tun
}

// --- Events: Cart-Änderungen vom Theme ---
// Wird vom Theme nach jeder Änderung am Cart gefeuert
document.addEventListener("cart:change", (e) => {
  if (!e.detail || !e.detail.cart) return;
  const cart = e.detail.cart;

  handleCartLogic(cart);
  adjustCartCountDisplay(cart);
});

// Wird vom Theme oder von uns gefeuert, wenn der Cart neu geladen werden soll
document.addEventListener("cart:refresh", () => {
  getCart()
    .then((cart) => {
      handleCartLogic(cart);
      adjustCartCountDisplay(cart);
    })
    .catch((err) =>
      console.error("❌ Fehler beim Abrufen des Carts (refresh):", err)
    );
});

// --- Initiales Setup bei Seitenaufruf ---
document.addEventListener("DOMContentLoaded", () => {
  getCart()
    .then((cart) => {
      handleCartLogic(cart);
      adjustCartCountDisplay(cart);
    })
    .catch((err) =>
      console.error("❌ Fehler beim initialen Laden des Carts:", err)
    );
});
